import { css } from '@emotion/core';
import theme from './settings';
export const makeStylesEls = [];

const makeStyle = obj => {
  if (typeof obj === 'function') {
    obj = obj(theme);
  }

  return props => {
    const classes = {};
    Object.keys(obj).forEach(key => {
      let CSS = obj[key];

      if (typeof CSS === 'function') {
        CSS = CSS(props);
      }

      CSS = css(CSS);
      const className = `css-${CSS.name}`;
      const style = CSS.styles;
      separateStyle(className, style);
      classes[key] = className;
    });
    return classes;
  };
};

const separateStyle = (className, style) => {
  const styles = [];

  while (style.includes('{')) {
    const start = style.match(/[^;]+\{/).index;
    const end = getEndBraces(style, style.indexOf('{') + 1);
    styles.push(style.slice(start, end + 1));
    style = style.slice(0, start) + style.slice(end + 1);
  }

  if (style) {
    if (style.includes('content:;')) {
      style = style.replace('content:;', 'content:"";');
    }

    createStyle(className, style);
  }

  if (styles.length) {
    styles.forEach(style => {
      const indexBraces = style.indexOf('{');
      const childClass = style.slice(0, indexBraces);
      style = style.slice(indexBraces + 1, style.length - 1);
      const separateClass = (childClass[0] === '&' ? '' : ' ') + childClass.replace('&', '');
      let newClass = '';

      if (separateClass.includes('@media')) {
        newClass = separateClass + '{.' + className;
        style += '}';
      } else {
        newClass = className + separateClass;
      }

      separateStyle(newClass, style);
    });
  }
};

const createStyle = (className, style) => {
  const styleEl = document.createElement('style');
  styleEl.type = 'text/css';
  styleEl.dataMeta = 'makeStyles';
  document.head.appendChild(styleEl);
  styleEl.appendChild(document.createTextNode(`${/@media/.test(className) ? '' : '.'}${className} {${style}}`));
  makeStylesEls.push(styleEl);
};

const getEndBraces = (str, start) => {
  let temp = 0;

  for (let i = start; i < str.length; i++) {
    if (str[i] === '}') {
      if (!temp) {
        temp = i;
        break;
      } else {
        temp--;
      }
    } else if (str[i] === '{') {
      temp++;
    }
  }

  return temp;
};

export default makeStyle;